import Picker from 'vux/src/components/picker/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { mapState } from 'vuex'
import { resetTextBylangKey } from '../../../../libs/options.js'
import LockAmountDetail from '../../../../components/base/lockAmountDetail'
import BScroll from 'better-scroll';
import { common, commonApi } from '@/common/index'
import loadMore from '@/common/components/load-more/index.vue'
export default {
components: {
LockAmountDetail,
InlineLoading,
XDialog,
XButton,
Picker,
Group,
loadMore
},
directives: {
TransferDom
},
data() {
return {
options: {
click: true,
scrollY: true, // 因为scrollY默认为true，其实可以省略
pullDownRefresh: {
threshold: 90, // 当下拉到超过顶部 50px 时，触发 pullingDown 事件
stop: 40 
},
pullUpLoad: {
threshold: -90,// 在上拉到超过底部 20px 时，触发 pullingUp 事件
stop: 40,
moreTxt: 'Load more',
noMoreTxt: 'There is no more data',
}
},
scroll: '',
isShowDialog: false,
topLoading: false,
downLoading: false,
pageNo: 1,
pageSize:10,
total: null,
condition: {
platform: '', // 平台
lock: '', // 锁定状态
bonus: '' 
},
finish: null
}
},
computed: {
...mapState({
UUID: state => state.UUID
}),
lockStatusOptions() {
return [resetTextBylangKey(this.status, this.$t('mine').lockAmount.loackAmonutOptions, 'name')]
}
},
methods: {
_refresh({ finish }) { // 刷新
this.finish = finish
this.pageNo = 1
this.depositQueryUserLockAmount()
},

_loadmore({ finish }) { // 加载更多
this.finish = finish
let le = this.depositList !== undefined ? this.depositList.length : this.discountsList.length
if (le === this.total) {
this.$vux.toast.show({ text: this.$t('others').noData1, type: 'cancel' });
this.finish()
return
}
this.pageNo += 1
this.depositQueryUserLockAmount()
},

_setConditionName(type) { // 设置条件名称
if (type === 'platform') this.condition[type] = this.allPlatform[0].filter((item) => (item.value === this.platformStatus[0]))[0]['name']
if (type === 'lock') this.condition[type] = this.lockStatusOptions[0].filter((item) => (item.value === this.lockStatus[0]))[0]['name']
if (type === 'bonus') this.condition[type] = this.bonusOptions[0].filter((item) => (item.value === this.bonusStatus[0]))[0]['name']
},


depositQueryUserLockAmount() {
commonApi.HOMEAFTER.queryUserLockAmount(this._getParams())
.then(data => {
const { list, total } = data.lockInfo
this.total = total
if (this.depositList !== undefined) this.depositList = this.pageNo === 1 ? list : [...this.depositList ,...list]
if (this.discountsList !== undefined) this.discountsList =this.pageNo === 1 ? list : [...this.discountsList ,...list]
if (this.finish) this.finish()
})
.catch(err => {
if (this.depositList !== undefined) this.depositList = []
if (this.discountsList !== undefined) this.discountsList = []
if (this.finish) this.finish()
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/LockAmount/mixins/lockMX.js